import type { IInputQuestion } from './_question';
import type { InputProps } from '../Inputs/TextInput';
import type { FieldErrors } from 'react-hook-form';

import Link from 'next/link';
import React from 'react';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

import Container from '../Container';
import TextInput from '../Inputs/TextInput';

import InputWrapper from './elements/InputWrapper';
import LoginBorderBottomSpan from './elements/LoginBorderBottomSpan';

import theme from '$/assets/theme';
import getControlError from '$/hooks/getControlError';

export const yupEmailInputQuestion = yup.string().email();

interface IEmailInputQuestion extends IInputQuestion, InputProps {
  onValueSelected?: () => void;
  errors: FieldErrors<any>;
}

const EmailInputQuestion = ({
  control,
  name,
  onValueSelected,
  title,
  errors,
  ...props
}: IEmailInputQuestion) => (
  <InputWrapper>
    <Controller
      control={control}
      name={name}
      render={({
        field,
        fieldState,
      }) => {
        const error = getControlError(control, name, props.errorMessage)
        const errorMessage = () => {
          return error.message;
          // TODO
          switch (errors?.email?.type) {
            case 'emailNotExistInCognito':
              return (
                <Container>
                  Diese E-Mail existiert bereits. Bitte benutze den&nbsp;
                  {
                    <Link href="/signin" passHref>
                      <LoginBorderBottomSpan>Login</LoginBorderBottomSpan>
                    </Link>
                  }
                  .
                </Container>
              );

            default:
              return 'Gib bitte eine korrekte E-mail-Adresse an.';
          }
        };

        return (
          <TextInput
            type="email"
            {...field}
            error={fieldState.invalid}
            success={fieldState.isDirty && !fieldState.invalid}
            iconPosition="end"
            containerProps={{
              style: {
                borderColor: fieldState.invalid
                  ? theme.colors.functionalRed
                  : fieldState.isDirty
                    ? theme.colors.brandGreen
                    : undefined,
              },
            }}
            {...props}
            errorMessage={errorMessage()}
          />
        );
      }}
    />
  </InputWrapper>
);

EmailInputQuestion.defaultProps = {
  placeholder: 'E-Mail',
  successMessage: 'Das passt, vielen Dank!',
};

export default EmailInputQuestion;
